/* eslint-disable @typescript-eslint/no-explicit-any */
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.mixin({
        mounted() {
            // Only apply to VForm components   
            if (this.$options.name === 'VForm') {
                /**
                 * Synchronously validate form and return final result
                 * Executes all synchronous validation rules immediately
                 * 
                 * @returns {{valid: boolean, errors: Array}}
                 */
                (this as any).validateSync = function() {
                    try {
                        this.validate()
                        const items = (this as any).items || []
                        const errors: any[] = []
                        let allValid = true
                        
                        for (const item of items) {
                            const vm = item.vm
                            if (!vm?.proxy) continue
                            
                            const props = vm.proxy.$props || vm.props
                            const rules = props?.rules || []
                            const modelValue = props?.modelValue
                            const validationValue = props?.validationValue !== undefined ? props.validationValue : modelValue
                            const maxErrors = Number(props?.maxErrors || 1)
                            
                            const fieldErrors: string[] = []
                            
                            // Execute validation rules synchronously
                            for (const rule of rules) {
                                if (fieldErrors.length >= maxErrors) break
                                
                                try {
                                    const handler = typeof rule === 'function' ? rule : () => rule
                                    const result = handler(validationValue)
                                    
                                    // Skip async results
                                    if (result && typeof result.then === 'function') continue
                                    
                                    if (result === true) continue
                                    
                                    if (result === false || typeof result === 'string') {
                                        fieldErrors.push(result === false ? '' : result)
                                    }
                                } catch (error) {
                                    console.error('Rule execution error:', error)
                                }
                            }
                            
                            // Update item state
                            item.isValid = fieldErrors.length > 0 ? false : true
                            item.errorMessages = fieldErrors
                            
                            if (fieldErrors.length > 0) {
                                allValid = false
                                errors.push({
                                    id: item.id,
                                    errorMessages: fieldErrors
                                })
                            }
                        }

                        
                        return allValid
                        
                    } catch (error) {
                        console.error('Validation error:', error)
                        return { valid: false, errors: [] }
                    }
                }
                
                // Add more custom methods as needed
            }
        }
    })
})
